import type { ListBuilderList } from '../../../types';
import {
	accountColumn,
	actionColumn,
	fileVsRegulatorColumn,
	licenseColumn,
	salesColumn,
	whyHereColumn,
} from '../columns';
import { hideOtherCardFilters, ownAccountsScopeRule } from '../filter-rules';

/**
 * Dead License (PD-16253) — active buyers holding a license the regulator shows
 * revoked, cancelled, retired, expired or otherwise unusable, whether the
 * license is linked to that record or only suggested to it at 90%+. The list
 * behind the dashboard's Dead License card: both filters are the dashboard's
 * own predicates, so the tab count, the card and the rows agree.
 */
export const deadLicenseList: ListBuilderList = {
	id: 'compliance-dead-license',
	cacheTTL: 300000,
	// Tab label, deliberately short: the tabs must fit the Needs Attention
	// strip at 1440px before the More dropdown swallows them (Chris,
	// 2026-09-20). The full name is above and on the dashboard card.
	name: 'Dead',
	type: 'default',
	active: true,
	sortOrder: 1,
	filterRules: {
		...hideOtherCardFilters([]),
		licenseSalesRep: ownAccountsScopeRule,
		licenseActiveBuyer: {
			defaultValue: [{ id: 'yes', label: 'Buying (sale in 90 days)' }],
			locked: true,
		},
		licenseRegistryStanding: {
			defaultValue: [{ id: 'unusable', label: 'Not Usable at State' }],
			locked: true,
		},
	},
	columns: [
		accountColumn,
		salesColumn,
		licenseColumn,
		fileVsRegulatorColumn,
		whyHereColumn,
		actionColumn,
	],
	defaultSortId: 'sales-90-desc',
};
